module.exports = __webpack_public_path__ + "img/brandenburg_2.513b9b4d.jpg";